export default __webpack_public_path__ + "media/images/portfolio/gallery-04-390x230-8761c6d4dacd19541f893f5d41ed59b2.jpg";